import { render, staticRenderFns } from "./LoginOrRegister.vue?vue&type=template&id=1bb53ec0&scoped=true&"
import script from "./LoginOrRegister.vue?vue&type=script&lang=js&"
export * from "./LoginOrRegister.vue?vue&type=script&lang=js&"
import style0 from "./LoginOrRegister.vue?vue&type=style&index=0&id=1bb53ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb53ec0",
  null
  
)

export default component.exports